module.exports = __webpack_public_path__ + "img/check.7738cd39.svg";